module.exports = __webpack_public_path__ + "static/media/doctor5-150.2cbc991c.webp";